import React from 'react'
import asyncComponent from '../../../util/asyncComponent'
import {Route,Switch} from 'react-router-dom'
const ClosingAndOthers=({match})=>(
    <Switch>
      <Route path={`${match.url}/ReverseBuyGoodsAndServices`} component={asyncComponent(()=>import('./ReverseBuyGoodsAndServices/index'))}/>
    </Switch>
)
export default ClosingAndOthers;